export default "__VITE_ASSET__ca8197a4__"